import React from "react";
import Article from "./Article";
import styles from "./SectionArticle.module.scss";
import cx from "classnames";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import { discoverPage } from "@utils/helper";
const View = ({ className }: any) => {
  const { pageData } = usePageContext();
  const articles = discoverPage.formatArticles(pageData);
  return (
    <section
      data-scroll-section
      className={cx("inner-large", styles.section, className)}
    >
      {_.map(articles, (item: any, index: number) => {
        return (
          <Article
            border="none"
            type={cx({
              ["left"]: index % 2 !== 0,
              ["right"]: index % 2 === 0,
            })}
            {...item}
            key={`card_${index}`}
          />
        );
      })}
    </section>
  );
};
export default View;
